var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 7.5V22.5H2.5V7.5",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1799 3.5H13.9399",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12.8284 6.5 13.5 5.82843 13.5 5C13.5 4.17157 12.8284 3.5 12 3.5C11.1716 3.5 10.5 4.17157 10.5 5C10.5 5.82843 11.1716 6.5 12 6.5Z",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8101 4.08C9.34007 2.61 7.22007 1.5 6.00007 1.5C4.78007 1.5 5.50007 3.66 5.50007 4.5C5.50007 5.34 5.31007 7.5 6.50007 7.5C7.69007 7.5 10.8601 6 10.8601 6",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.22 4.16C14.69 2.69 16.78 1.5 18 1.5C19.22 1.5 18.5 3.66 18.5 4.5C18.5 5.34 18.69 7.5 17.5 7.5C16.31 7.5 13.23 5.91 13.23 5.91",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67 6.5L8.5 9.5L10 9L10.5 10.5L12 6.5",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.38 6.44995L15.5 9.49995L14 8.99995L13.5 10.5L12 6.49995",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22.5V10.5",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5V22.5",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6299 7.5H12.3799L11.9999 6.5L11.6299 7.5Z",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.5H22.5V3.5H18.62",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38 3.5H1.5V7.5H9.25",
    stroke: "#303C42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.9551ff48e0263d693ed8ecc660bbb7a1.svg";
export { ForwardRef as ReactComponent };